import React from 'react';

let defaultDataState = {
    'jurisdiction' : {},
    'condition' : {}
};


const DataContext = React.createContext(defaultDataState);

export const DataContextProvider = DataContext.Provider;
export const DataContextConsumer = DataContext.Consumer;

